import { render, staticRenderFns } from "./product_list_mdoal.vue?vue&type=template&id=83da3cf6&"
import script from "./product_list_mdoal.vue?vue&type=script&lang=js&"
export * from "./product_list_mdoal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports